<div class="modal-wrapper sm:max-w-md md:max-w-lg">

    <!-- Cancel Icon -->
    <img src="assets/icons/cancel.svg" alt="Cancel Icon"
        class="modal-close-icon rtl:mr-auto! rtl:ml-0!" (click)="close()" />
    <!-- header icon -->
    <img src="assets/icons/user-add.svg" alt="Icon" class="mb-6 mx-auto w-14 h-14" />

    <h3 class="mb-8 modal-title">
        {{'BUSINESS_ONBOARDING.OPEN_ACCOUNT' | translate}}</h3>

    <div class="setting-card shadow-(--shadow-input)">
        <div class="setting-item">
            <div class="text-start">
                <p class="leading-[26px] font-semibold text-xl mb-2 text-(--text-primary)">
                    {{'BUSINESS_ONBOARDING.START_ONBOARDING' | translate}}
                </p>
                <p class="text-base font-medium leading-5 text-(--text-muted)">
                    {{'BUSINESS_ONBOARDING.REGISTER_COMPANY' | translate}}
                </p>
            </div>
        </div>
        <button class="setting-arrow" (click)="startOnboarding()">
            <img src="assets/icons/arrow-right-sm.svg" class="w-4 h-4 rtl:rotate-180" alt="arrow icon" />
        </button>
    </div>

    <div class="setting-card shadow-(--shadow-input)">
        <div class="setting-item">
            <div class="text-start">
                <p class="leading-[26px] font-semibold text-xl mb-2 text-(--text-primary)">
                    {{'BUSINESS_ONBOARDING.CONTINUE_APPLICATION' | translate}}
                </p>
                <p class="text-base font-medium leading-5 text-(--text-muted)">
                    {{'BUSINESS_ONBOARDING.RESUME_APPLICATION' | translate}}
                </p>
            </div>
        </div>
        <button class="setting-arrow" (click)="referenceIdModal()">
            <img src="assets/icons/arrow-right-sm.svg" class="w-4 h-4 rtl:rotate-180" alt="arrow icon" />
        </button>
    </div>

</div>